import { gql } from '@apollo/client'

export const MUTATION_REASSIGN_DEVICE = gql`
  mutation mutationReassignDevice($rentalID: ID!, $employeeID: ID!) {
    reassignDevice(rentalID: $rentalID, employeeID: $employeeID) {
      id
    }
  }
`
